export default function AboutSection() {
  return (
    <section id="about-section" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs font-label font-semibold uppercase tracking-wider text-primary-500 mb-3">
            Our Mission
          </p>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 leading-tight mb-6">
            Building the Most Trusted Hipobuy Spreadsheet Resource on the Web
          </h2>

          <div className="space-y-5 text-sm md:text-base font-body text-foreground-700 leading-relaxed">
            <p>
              In a digital world overflowing with fragmented shopping information, the Hipobuy Spreadsheet project was born from a simple observation: organized data beats scattered browsing every single time. We built this hub to centralize the best product discovery resources into one accessible, searchable, and consistently maintained platform.
            </p>
            <p>
              Our research methodology combines community-sourced discoveries with systematic category organization. Every spreadsheet is verified for accuracy before being added to the database. Categories are regularly reviewed and updated to reflect current market trends and user demand — ensuring the Hipobuy Spreadsheet remains the most reliable resource in its space.
            </p>
            <p>
              We believe in transparency. This website does not collect payments, does not require registration, and does not track personal data. Every external link is clearly marked. The Hipobuy Spreadsheet project exists purely to help shoppers discover organized product resources more efficiently — nothing more, nothing less.
            </p>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-md">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shield-check-line text-accent-500"></i>
              </span>
              <span className="text-xs font-label font-medium text-foreground-700 whitespace-nowrap">Safe Browsing</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-md">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-lock-line text-accent-500"></i>
              </span>
              <span className="text-xs font-label font-medium text-foreground-700 whitespace-nowrap">Privacy Protected</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-md">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-refresh-line text-accent-500"></i>
              </span>
              <span className="text-xs font-label font-medium text-foreground-700 whitespace-nowrap">Updated Monthly</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-md">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-eye-line text-accent-500"></i>
              </span>
              <span className="text-xs font-label font-medium text-foreground-700 whitespace-nowrap">Transparent Resources</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}